import request from '../../../helpers/request';

export const getMeter = async (meterId) => {
  return await request.get(
    `/RentPlace/meter/${meterId}`,
    {},
    'При загрузке счетчика произошла ошибка',
    {}
  );
};
